var r=function(r){return function(n){var t=r;return Object.entries(n).forEach((function(r){var n=r[0],e=r[1];return t=t.replace("{{".concat(n,"}}"),e)})),t}};function n(n,t){return t?r(n)(t):r(n)}export{n as formatString};
//# sourceMappingURL=formatString.js.map
